import React, { ReactElement } from "react";
import { formatPhoneNumber } from "@eave/shared/utils/phone";

const titleize = require("underscore.string/titleize");

// Returns an address as a single-line:
// 10 Orange Ln, Cupertino CA 12345
export const addressToStr = (
  line1: string,
  line2: string,
  city: string,
  state: string,
  zip: string,
): string => {
  if (!city || !state) return "";

  let address = `${titleize(city)}, ${state}`;
  if (line1 && line2 && zip) {
    address = `${titleize(line1)}, ${titleize(line2)}, ${address} ${zip}`;
  } else if (line1 && zip) {
    address = `${titleize(line1)}, ${address} ${zip}`;
  }
  return address;
};

// Returns a <p> containing a formatted address as a 2-liner:
// 10 Orange Ln, Apt 3D
// Cupertino, CA 12345
export const addressToPostalFormatStr = (
  line1: string,
  line2: string,
  city: string,
  state: string,
  zip: string,
  contact?: string,
): ReactElement | string => {
  if (!city || !state) return "";

  let address: ReactElement | string = `${titleize(city)}, ${state}`;

  if (line1 && zip) {
    return (
      <p>
        {titleize(line1)}
        {line2 ? `, ${titleize(line2)}` : ""}
        <br />
        {`${address} ${zip}`}
        {contact && (
          <>
            <br />
            {formatPhoneNumber(contact)}
          </>
        )}
      </p>
    );
  }

  return address;
};
